// Builds the HubSpot / Marketo CTA embed forms from data-* attributes instead of an
// inline <script> in _cta_modal_form, so the code is covered by script-src 'self'
// rather than tripping a CSP violation.
//
// The external loader scripts (js.hsforms.net, the client's marketo forms2.js) still
// load via allow-listed <script src> tags in the partial. Those tags block parsing,
// so by DOM-ready their globals (hbspt / MktoForms2) are defined and safe to call here.
$(() => {
  $('.js-hubspot-cta-form').each(function(i) {
    if (typeof hbspt === 'undefined') { return; } // loader blocked (e.g. ad blocker)

    if (!this.id) { this.id = `js-hubspot-cta-form-${i}`; }
    const $el = $(this);

    hbspt.forms.create({
      portalId: String($el.data('portal-id')),
      formId: String($el.data('form-id')),
      sfdcCampaignId: String($el.data('sfdc-campaign-id') || ''),
      region: String($el.data('region') || 'na1'),
      target: `#${this.id}`,
      onFormReady: function($form) {
        const input_name = $('#cta-form-field-for-pdf').val();
        $form.find(`input[name="${input_name}"]`).val($('#prospect-pdf-url').val()).change();
      }
    });
  });

  $('.js-marketo-cta-form').each(function() {
    if (typeof MktoForms2 === 'undefined') { return; } // loader blocked (e.g. ad blocker)

    const $el = $(this);
    const load_src = String($el.data('load-src'));
    const user_id = String($el.data('user-id'));
    const form_id = $el.data('form-id');

    // Some clients hide the form on success; others rely on Marketo's default follow-up.
    if ($el.data('hide-on-success')) {
      MktoForms2.loadForm(load_src, user_id, form_id, function(form) {
        form.onSuccess(function() {
          form.getFormElem().hide();
          return false;
        });
      });
    } else {
      MktoForms2.loadForm(load_src, user_id, form_id);
    }
  });
});
